import axios from 'axios';
/**
 * 作品相关
 */
export default {
	/**
   * 发送验证码
   */
	async sendSMSCode(telNumber) {
		let { data } = await axios.get(`/sms?telNumber=${telNumber}`);
		return data;
	},
	/**
   * 上传作品
   */
	async uploadWorks(dataParams) {
		let { data } = await axios.post(`/works/upload`, dataParams);
		return data;
	},
	/**
   * 更新图片类型
   */
	async updatePicType(dataParams) {
		let { data } = await axios.post(`/works/updatePicType`, dataParams);
		return data;
	},
	/**
   * 获取图片列表
   */
	async fetchImgList(options) {
		// let { data } = await axios.get(`/works/nonPage`);
		// return data;
		let { data } = await axios.get(`/works/list?page=1&limit=${options.limit}&sort=${options.sort}&type=${options.type}&hodingTime=${options.hodingTime}`);
		return data;
	},
	/**
   * 获取每周最佳作品
   */
	async weekChampion(type,hodingTime = 2022) {
		let { data } = await axios.get(
			`/works/weekChampion?type=${type}&hodingTime=${hodingTime}`
		);
		return data;
	},
	/**
   * 获取产品列表（查询、分页）
   */
	async fetchWorksList(options) {
		let { data } = await axios.get(
			`/works/list?page=${options.page || 1}&limit=20&name=${options.keyword || ''}&sort=${options.sort}&type=${options.type || 0}&hodingTime=${options.hodingTime}`
		);
		return data;
	},

	/**
   * 查询无作品的时候，获取猜测的图片
   */
	async fetchGuessImg(options) {
		let { data } = await axios.get(
			`/works/nonPage?page=${options.page || 1}&limit=20&name=${options.keyword || ''}&sort=${options.sort || ''}&type=${options.type || 0}&hodingTime=${options.hodingTime}`
		);
		return data;
	},


	/**
   * 获取产品详情
   */
	async fetchWorksDetails(id) {
		let { data } = await axios.get(`/works/details?worksId=${id}`);
		return data;
	},
	/**
   * 校验图片是否上传成功
   */
	async judgeImg(url) {
		let { data } = await axios.get(url);
		return data;
	},
	/**
   * 投票
   */
	async voteWorks(id, token) {
		let { data } = await axios.post(
			`/works/vote`,
			{ notesIds: Array.isArray(id) ? id : [ id ] },
			{ headers: { Authorization: token } }
		);
		return data;
	}
};
